import React from 'react';
import { WRAP, SECTION_PAD } from '../styles/layout';
import { Helmet } from 'react-helmet-async';

const BG  = '#09060F';
const C   = '#00D4AA';
const R   = '0,212,170';
const LAV = '#EDE9F8';
const LAV2= '#C8C0EC';
const LAV3= '#9B90BA';

const H2 = ({ children }) => (
  <h2 style={{ fontFamily:"'Fraunces',Georgia,serif", fontWeight:800, fontSize:'clamp(20px,1.8vw,26px)', color:LAV, margin:'40px 0 14px', letterSpacing:'-0.5px', lineHeight:1.2 }}>{children}</h2>
);
const P = ({ children, style={} }) => (
  <p style={{ fontFamily:"'DM Sans',system-ui,sans-serif", fontSize:15, fontWeight:300, lineHeight:1.85, color:LAV3, margin:'0 0 16px', ...style }}>{children}</p>
);
const Li = ({ children }) => (
  <li style={{ fontFamily:"'DM Sans',system-ui,sans-serif", fontSize:15, fontWeight:300, lineHeight:1.85, color:LAV3, margin:'0 0 8px' }}>{children}</li>
);

export default function TermsOfService() {
  return (
    <>
      <Helmet>
        <title>Terms of Service — RevUpAI</title>
        <meta name="description" content="RevUpAI Terms of Service. Governed by the laws of the State of Texas." />
        <link rel="canonical" href="https://revupai.com/terms" />
        <meta name="robots" content="noindex" />
      </Helmet>
    <div style={{ background:BG, minHeight:'100vh', paddingTop:80 }}>
      <div style={{ ...WRAP, maxWidth:780, padding:`${SECTION_PAD} clamp(20px,4vw,40px)` }}>

        {/* Header */}
        <div style={{ marginBottom:48, paddingBottom:32, borderBottom:`1px solid rgba(${R},.15)` }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'5px 14px', borderRadius:100, background:`rgba(${R},.08)`, border:`1px solid rgba(${R},.2)`, marginBottom:24 }}>
            <span style={{ fontSize:11, fontWeight:700, letterSpacing:2.5, textTransform:'uppercase', color:C }}>Legal</span>
          </div>
          <h1 style={{ fontFamily:"'Fraunces',Georgia,serif", fontWeight:900, fontSize:'clamp(32px,3.5vw,52px)', color:LAV, margin:'0 0 16px', letterSpacing:'-1.5px', lineHeight:1.08 }}>Terms of Service</h1>
          <P style={{ color:LAV2 }}>Effective date: 1 January 2026 · Last updated: 1 January 2026</P>
          <P>Please read these Terms of Service carefully before using RevUpAI's website or services. By accessing or using our services, you agree to be bound by these terms.</P>
        </div>

        <H2>1. About us</H2>
        <P>RevUpAI ("RevUpAI", "we", "us") provides Operated AI roles and related services to enterprise clients. Based in Dallas, Texas. For questions: <a href="mailto:legal@revupai.com" style={{ color:C, textDecoration:'none' }}>legal@revupai.com</a>.</P>

        <H2>2. Acceptance of terms</H2>
        <P>By accessing revupai.com or engaging RevUpAI's services, you confirm that you are authorised to accept these terms on behalf of your organisation and that your organisation agrees to be bound by them.</P>

        <H2>3. Our services</H2>
        <P>RevUpAI provides Operated AI roles — including AI CISO, AI Architect, AI DBA, AI QA, and custom AI roles — deployed and operated within client environments. The specific scope, deliverables, timelines, and commercial terms of each engagement are set out in a separate Statement of Work or Order Form, which forms part of these terms.</P>

        <H2>4. Acceptable use</H2>
        <P>You agree not to:</P>
        <ul style={{ margin:'0 0 16px', paddingLeft:24 }}>
          <Li>Use our services for any unlawful purpose or in violation of applicable law</Li>
          <Li>Attempt to gain unauthorised access to our systems or infrastructure</Li>
          <Li>Reverse engineer, decompile, or disassemble any part of our software or AI systems</Li>
          <Li>Resell, sublicense, or transfer our services to third parties without written consent</Li>
          <Li>Use our services to develop competing products or services</Li>
        </ul>

        <H2>5. Intellectual property</H2>
        <P>RevUpAI retains all intellectual property rights in its platform, methodologies, frameworks, and underlying AI systems. Unless expressly agreed in writing, custom work product delivered to clients is licensed, not sold, and remains subject to RevUpAI's underlying IP.</P>

        <H2>6. Confidentiality</H2>
        <P>Both parties agree to keep confidential any non-public information disclosed during the engagement. Confidentiality obligations survive termination of the engagement for a period of three years, except for information that enters the public domain through no fault of the receiving party.</P>

        <H2>7. Data processing</H2>
        <P>Where RevUpAI processes personal data on your behalf in the course of delivering services, the parties will enter into a Data Processing Agreement in accordance with applicable data protection law. Our <a href="/privacy" style={{ color:C, textDecoration:'none' }}>Privacy Policy</a> governs personal data collected through our website.</P>

        <H2>8. Warranties and disclaimers</H2>
        <P>RevUpAI warrants that it will deliver services with reasonable skill and care. To the fullest extent permitted by law, we disclaim all other warranties, express or implied. AI systems are probabilistic in nature; we do not warrant that outputs will be error-free or suitable for any particular purpose without appropriate human oversight.</P>

        <H2>9. Limitation of liability</H2>
        <P>To the maximum extent permitted by applicable law, RevUpAI's total aggregate liability arising out of or in connection with these terms shall not exceed the fees paid by you in the three months preceding the claim. We exclude liability for indirect, consequential, or punitive damages in all cases.</P>

        <H2>10. Termination</H2>
        <P>Either party may terminate an engagement with 30 days' written notice unless a specific notice period is set out in the relevant Order Form. RevUpAI may terminate immediately for material breach, non-payment, or insolvency. On termination, each party will return or destroy the other's confidential information.</P>

        <H2>11. Governing law</H2>
        <P>These terms are governed by the laws of the State of Texas, United States, without regard to its conflict of law provisions. Any disputes shall be subject to the exclusive jurisdiction of the state and federal courts located in Dallas County, Texas.</P>

        <H2>12. Changes to these terms</H2>
        <P>We may update these terms from time to time. Continued use of our services after notice of changes constitutes acceptance of the updated terms.</P>

        <H2>13. Contact</H2>
        <P>For legal enquiries: <a href="mailto:legal@revupai.com" style={{ color:C, textDecoration:'none' }}>legal@revupai.com</a></P>

      </div>
    </div>
    </>
  );
}